// SIDE COLUMN

$(window).on('load', function() {
  
  var w = $(window).width();
  //var x = 1025;
  var x = 9999999;
  var $kv = $('.side-movie');
				




  if(w < x) {
    
    var webStorage = function() {
			
			
      //if(sessionStorage.getItem('access00')) {
			if( location.pathname !== '/' ){
				//console.log('セカンドページです'); 
			} else if(sessionStorage.getItem('access')) {
        $('#sideColumn').hide();
				//console.log('access_hide');
      } else {
        sessionStorage.setItem('access', 0);
				//console.log('access_yes');
        $kv.slick({
          autoplay: true,
          autoplaySpeed: 1600,
          infinite: false,
          fade: true,
          arrows: false,
        }).on('afterChange', function(event, slick, currentSlide, nextSlide) {
          
          //switch (currentSlide) {
          //  case 0:
          //    $(this).slick("slickSetOption", "autoplaySpeed", 1000);
          //    break;
          //  case 1:
          //    $(this).slick("slickSetOption", "autoplaySpeed", 1200);
          //    break;
          //}
          
          var slideCount = slick.slideCount - 1;
          if (slideCount == currentSlide) {
						
            $(this).slick('slickPause');
            $('#sideColumn').delay(1800).queue(function() {
              $(this).addClass('start');
							
							//スライドショーが消えた0.2秒後にスクロール解除
							$('body').delay(200).queue(function(){
								$(this).removeClass('no-scroll');
							})
							
            })
          }
        });
				

				$(".side-movie").bind("touchstart", onTouchStart);
				$(".side-movie").bind("touchmove", onTouchMove);
				$(".side-movie").bind("touchend", onTouchEnd);
				var direction, position;

				//スワイプ開始時の横方向の座標を格納
				function onTouchStart(event) {
						position = getPosition(event);
				}

				//スワイプの方向（left／right）を取得
				function onTouchMove(event) {
					direction = (position > getPosition(event)) ? "left" : "right";
				}

				//スワイプ終了時に方向（left／right）をクラス名に指定
				function onTouchEnd(event) {
					//$("div#touch").removeAttr("class").addClass(direction);
          $("#sideColumn").addClass('start');
				}

				//横方向の座標を取得
				function getPosition(event) {
					return event.originalEvent.touches[0].pageX;
				}



				//スワイプしたらメインビジュアル非表示
				$('body').addClass('no-scroll');
				
				$("#sideColumn").on("touchmove",function() {
					//alert('swipe!');
					$(this).addClass('start');
					
					//スライドショーが消えた0.2秒後にスクロール解除
					$('body').delay(200).queue(function(){
						$(this).removeClass('no-scroll');
					})
				});

				
				//クリックしたらメインビジュアル非表示
				$("#sideColumn").click(function() {
					//alert('click!');
					$(this).addClass('start');
					
					//スライドショーが消えた0.2秒後にスクロール解除
					$('body').delay(200).queue(function(){
						$(this).removeClass('no-scroll');
					})
				});

				
				
      }
    }
    webStorage();
		
		

    
  } else {
    $kv.slick({
      autoplay: true,
      infinite: true,
      fade: true,
      autoplaySpeed: 5000,
      speed: 2000,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false
    });
  }
});

// HEADER
$(function() {
  var headerH = $('header').outerHeight(true);
  headerH = 5;
	
	$('.header__icon--search').click(function() {
    $('html, body').animate({
      scrollTop: 0
    }, 1);
  })

  function FixedAnime() {
    var scroll = $(window).scrollTop();
    
    if (scroll >= headerH){
      $('.search__container').addClass('hide');
      $('.header__icon--search').addClass('show-icon');
      $('.mobile-facets').css('padding-top', '93px' );
    }
    else {
      $('.search__container').removeClass('hide');
      $('.header__icon--search').removeClass('show-icon');
      $('.mobile-facets').css('padding-top', '141px' );
    }
  }
  
  $(window).scroll(function() {
    FixedAnime();
  });
  
  // Filters
  $('.mobile-facets__header-inner').on('click', function() {
    $(this).parents('details').removeAttr('open');
  });
  
  $('.header__icon--search').click(function() {
    $(this).removeClass('show-icon');
    $('.search__container').removeClass('hide');
  });
  
  $('a[href^="#"]').not('.noscroll, .jdgm-write-rev-link').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		
		var headerHeight = headerH + 20;
		var position = target.offset().top-headerHeight;
		
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
});

// TOPスライダー
$(function() {
  
  const $slider = $('.ad-slides');
  
  //トップスライダーページ番号
  $slider.on('init', function(event, slick) {
    $(this).prepend('<div class="slick-counter"><span class="current"></span>/<span class="total"></span></div>');
    $('.current').text(slick.currentSlide + 1);
    $('.total').text(slick.slideCount);
  })
  $slider.slick({
    dots: true,
    autoplay: true,
    centerMode: true,
    centerPadding: '60px',
    draggable: false
  })
  .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.current').text(nextSlide + 1);
  });
});

// TABメニュー
$(function() {
  
  var $tab = $('.tab-list__item');
  var $tabContent = $('.tab-list-content,.detail-tab-content');
  
  $tab.on('click', function() {
    
    let index = $tab.index(this);
    
    $tab.removeClass('is-active');
    $(this).addClass('is-active');
    $tabContent.hide().eq(index).fadeIn(800);
  });
});

// メニュー
$(function() {
  $('h2.footer-block__heading').click(function() {
    $(this).next('ul').slideToggle('fast');
    $(this).toggleClass('opened');
  });
  
  $('.nav-main .parent>a').removeAttr('href').attr('tabindex', '-1');
  $('.nav-main .parent>a').click(function() {
    $(this).next('.child').slideToggle('fast');
    $(this).toggleClass('opened');
  });
});

// アンカーリンク
$(window).on('load', function() {
  let headerHeight = $('header').outerHeight() + 35;
  let hash = location.hash;
  if (hash) {
    let position = $(hash).offset().top - headerHeight;
    $('html, body').animate({ scrollTop: position }, 0);
  }
});

// 商品詳細
$(function() {

// 商品画像
  $('.product__media-list').slick({
    asNavFor: '.thumbnail-list',
    arrows: true,
  });
  
  $('.thumbnail-list').slick({
    asNavFor: '.product__media-list',
    slidesToShow: 12,
    arrows: false,
    focusOnSelect: true,
  });
});

// 固定ページスライダー
$(function() {
  
  const $photos = $('.photo-slider');
  
  $photos.on('init', function (event, slick) {
    $(this).prepend('<div class="slick-counter"><span class="current"></span><span class="total"></span></div>');
    $('.current',this).text(slick.currentSlide + 1);
    $('.total',this).text(slick.slideCount);
  })
  $photos.slick(
  )
  .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.current',this).text(nextSlide + 1);
  });
  
  $('.tab-list__item').on('click', function() {
    $photos.slick('setPosition');
  });
});

// 読みものページスライダー
$(function() {
  
  const $articleSlider = $('.article-slides');
  
  $articleSlider.slick({
    centerMode: true,
    centerPadding: '65px',
  });
  
  var h = $('.article-slide__media').outerHeight();
  var pos =  h / 2;
  $('.article-slides>.slick-arrow').css('top', pos );
  
});

// Modal
$(function() {
  
  var $trigger = $('.modal-trigger');
  var $modal = $('.modal-items_container, .modal-layer');
  var $item = $('.modal-item');
  
  $trigger.on('click', function() {
    
    let index = $trigger.index(this);
    
    $(this).addClass('is-shown');
    $modal.fadeIn();
    $item.hide().eq(index).fadeIn(800);
    $('body').addClass('no-scroll');
  });
  
  $('.btn-close, .modal-layer').on('click', function() {
    $(this).remove('is-shown');
    $item.fadeOut();
    $modal.fadeOut();
    $('body').removeClass('no-scroll');
  });
});

// Accordion
$(function() {
  $('.btn-trigger').on('click', function() {
    $(this).next('div').slideToggle('fast');
    $(this).toggleClass('opened');
  });
});

// アカウント
$(function() {
  $('.btn-edit-address').on('click', function() {
    var form = $(this).parents('li').find('.edit-address');
    form.slideToggle('fast');
    form.toggleClass('opened');
  });
  
  $('.cancel-editing').on('click', function() {
    $(this).parents('.edit-address').slideUp('fast').removeClass('opened');
  });
  
  var anchor = location.hash;
  var loginCont = $('#MainContent>.shopify-section:nth-child(-n+4)');
  var loginCont02 = $('#MainContent>.shopify-section:nth-child(1)');
  var loginCont03 = $('#MainContent>.shopify-section:nth-child(2)');
  
  if (anchor == '#recover') {
    //loginCont.hide();
    loginCont02.hide();
    loginCont03.hide();
  }
  else if (anchor == '#login') {
    loginCont.show();
  }
  
  $('a[href="#recover"]').on('click', function() {
    //loginCont.hide();
    loginCont02.hide();
    loginCont03.hide();
  });
  
  $('a[href="#login"]').on('click', function() {
    loginCont.show();
  });
});

// Validation Check
$(function() {
  let checkedsum;
  $('.contact-subject').on("click",function(){
    checkedsum = $('.contact-subject:checked').length;
    if ( checkedsum > 0 ) {
        $('.contact-subject').prop("required",false);
    } else {
        $('.contact-subject').prop("required",true);
    }
  });
});

// CSS Customize
$(function() {
  $('.globo-form-app .content+p').css('display', '');
});

// Preorder Popup
$(window).on('load', function() {
  var preorder = $('.preorder');
  
  preorder.delay(800).queue(function() {
    $(this).addClass('popup');
  })
  
  preorder.on('click', function() {
    $(this).removeClass('popup');
  });
});